import React from 'react';
import styled from 'styled-components/native';
import {useTheme} from 'styled-components';
import TextGeneric from '../textGeneric';
import Icon from '../icon';
import {tr} from '../../translations';
import {EmptyListProps} from '../../interfaces/components/emptyList';
import {Platform} from 'react-native';
import {Theme} from '../../theme/lightTheme';
import GenericButton from '../button';

const Container = styled.View`
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${({theme}) => theme.cardBackground};
  padding: ${({theme}) => theme.text.s1}px ${({theme}) => theme.text.s12}px;
  border-radius: ${({theme}) => theme.text.s55}px;
`;
const Title = styled(TextGeneric)`
  font-size: ${({theme}) => theme.text.s7}px;
  color: ${({theme}) => theme.text.dark};
  margin-top: ${({theme}) => theme.text.s55}px;
  text-align: center;
  width: 80%;
`;

const EmptyList: React.FC<EmptyListProps> = ({
  iconName,
  iconSize,
  iconColor,
  title,
  showRefresh = false,
  onRefreshPress,
  inverted = false,
  containerStyle,
  titleStyle,
  buttonStyle,
}) => {
  const theme = useTheme() as Theme;

  return (
    <Container
      style={[
        inverted && {
          transform: [
            Platform.OS === 'ios' ? {scaleY: -1} : {rotate: '180deg'},
          ],
        },
        containerStyle,
      ]}>
      {!!iconName && (
        <Icon
          name={iconName}
          size={iconSize || theme.text.s1}
          color={iconColor || theme.icon}
        />
      )}
      <Title semiBold style={titleStyle}>
        {tr(title)}
      </Title>
      {showRefresh && (
        <GenericButton
          isSmall
          style={[
            {
              backgroundColor: theme.icon,
              marginTop: '5%',
            },
            buttonStyle,
          ]}
          backgroundColor={theme.icon}
          dynamicWidth
          label={tr('app.tryAgain')}
          labelStyle={{
            fontSize: theme.text.s9,
            minWidth: theme.text.s9 * 13,
            textAlign: 'center',
          }}
          onPress={onRefreshPress}
        />
      )}
    </Container>
  );
};

export default EmptyList;
